// Mock data for Laliel Store

export const navLinks = [
  { id: 'home', label: 'ANA SƏHIFƏ', href: '/' },
  { id: 'products', label: 'MƏHSULLAR', href: '/#products' },
  { id: 'about', label: 'HAQQIMIZDA', href: '/#about' },
  { id: 'delivery', label: 'ÇATDIRILMA', href: '/catdirilma' },
  { id: 'contact', label: 'ƏLAQƏ', href: '/elaqe' },
  { id: 'blog', label: 'BLOQ', href: '/blog' }
];

export const features = [
  {
    id: 1,
    title: 'Keyfiyyət Zəmanəti',
    description: 'Yalnız premium keyfiyyətli materiallar və İtalyan parçaları',
    icon: 'shield-check'
  },
  {
    id: 2,
    title: 'Sürətli Çatdırılma',
    description: 'Bakı üzrə 24 saat, regionlara 2-3 gün ərzində çatdırılma',
    icon: 'truck'
  },
  {
    id: 3,
    title: 'Qaytarma Zəmanəti',
    description: '7 gün ərzində pulsuz qaytarma və dəyişdirmə',
    icon: 'refresh-cw'
  }
];

export const footerLinks = {
  alisvaris: [
    { label: 'Ana Səhifə', href: '#' },
    { label: 'Məhsullar', href: '#products' },
    { label: 'Haqqımızda', href: '#about' },
    { label: 'Əlaqə', href: '#contact' },
    { label: 'Bloq', href: '#blog' }
  ],
  xidmetler: [
    { label: 'Çatdırılma və Qaytarma', href: '#' },
    { label: 'Göndərmə Siyasəti', href: '#' },
    { label: 'Müştəri Xidməti', href: '#' },
    { label: 'Karyera', href: '#' }
  ],
  huquqi: [
    { label: 'Məxfilik Siyasəti', href: '#' },
    { label: 'İstifadə Şərtləri', href: '#' },
    { label: 'WhatsApp Sifariş', href: 'https://wa.me/994999737000' }
  ]
};

export const contactInfo = {
  whatsapp: '+994 99 973 70 00',
  instagram: '@laliel.az',
  website: 'www.lalielstore.com',
  address: 'Metropark, 4-cü mərtəbə',
  city: 'Bakı, Azərbaycan'
};
